import { CapoPlugin } from "/home/runner/work/Frontend-MKTPLC/Frontend-MKTPLC/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];